<template>
  <div class="exchangeable-products-wrapper new-exchangeable-product-wrapper">
    <SessionContent></SessionContent>
    <div class="change-product change-product-padding position-relative pt-0 exchangeable-products mx-3 px-0">
      <div v-if="activeSession && !activeSession.is_popup" class="bg-white position-absolute ch-prod-bg"></div>
      <section class="boxes">
        <b-row class="justify-content-md-center">
          <b-col lg="10" class="pl-sm-3 pr-sm-3 pl-0 pr-0">
            <template v-if="selectedItem && originalProduct">
              <h6 class="exchangeable-heading mb-0 mb-md-3">Current Order</h6>
              <ExchangeProduct
                :product="originalProduct"
                :selected="isSelected(originalProduct.to_campaign_product, originalProduct.quantity, originalProduct.price, originalProduct.to_variant)"
                :original="true"
                :item="selectedItem"
                @select="selectExchangeableProduct"
              ></ExchangeProduct>
              <div v-if="exchangeableProducts.length">
                <hr />
                <h6 class="exchangeable-heading mt-3">Other Package Options</h6>
                <div class="exchangeable-subheading">*Replace Current Order With Another Package below:</div>
                <ExchangeProduct
                  v-for="exchangeableProduct in exchangeableProducts"
                  :key="exchangeableProduct.id"
                  :product="exchangeableProduct"
                  :selected="isSelected(exchangeableProduct.to_campaign_product, exchangeableProduct.quantity, exchangeableProduct.price, exchangeableProduct.to_variant)"
                  :original="false"
                  :item="selectedItem"
                  @select="selectExchangeableProduct"
                ></ExchangeProduct>
              </div>
              <div v-else>
                <h6 class="mt-2">Quantity</h6>
                <b-form-select id="quantity" class="form-control border" :value="selectedQuantity" @input="updateQuantity($event)">
                  <option v-for="i in (maxQuantity - minQuantity) + 1" :key="i" :value="i + minQuantity - 1">{{i + minQuantity - 1}}</option>
                </b-form-select>
              </div>
              <div class="order-totals bold mr-3 align-items-center d-flex justify-content-end">
                <div class="label price pr-1 pr-sm-3">Total: </div>
                <div class="notranslate price mr-0">{{totalPrice}}</div>
              </div>
            </template>
          </b-col>
        </b-row>
      </section>
    </div>
    <div>
      <b-row>
        <b-col class="my-class">
          <h4 class="refund-text">*We will issue a refund of the difference you paid.</h4>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center boxes claim" :class="{'new-btns-container': !activeSession.is_legacy}">
        <b-col :md="!activeSession.is_legacy ? 8 : 6" lg="6" :class="{'my-class': !activeSession.is_legacy}">
          <b-row class="choice-fields-btns">
            <b-col v-for="input in activeSession.valid_inputs" :key="'choice-' + input.id" md="12" class="text-center">
              <b-link v-if="isLink(input)"
                      @click="selectInput(input)"
                      class="input-link"
                      :class="getCustomClass(input)"
                      :style="getStyles(input)"
                      v-html="sessionInputLabel(input)"
              ></b-link>
              <button v-else
                      @click="selectInput(input)"
                      class="btn-base input-choice-btn"
                      :class="getCustomClass(input, true)"
                      :style="getStyles(input)">
                <div v-html="sessionInputLabel(input)"></div>
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <StepBackButton v-if="activeSession && activeSession.is_legacy" @back="goBack" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {InputType, StepButtonType} from '@/constants'
import {formatCurrency, getClassFromObject, updateFontSizes} from '@/utils'
import axios from 'axios'
import SessionContent from './SessionContent'
import StepBackButton from '@/components/StepBackButton'
const ExchangeProduct = () => import('./ExchangeProduct')

export default {
  name: 'SelectExchangeProduct',
  components: {StepBackButton, ExchangeProduct, SessionContent},
  props: {
    item: Object,
    checkPrice: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data: function() {
    return {
      originalProduct: null,
      selectedExchangeableProduct: null,
      selectedItem: null,
      selectProductFields: {},
      minQuantity: 1,
      maxQuantity: 10,
      exchangeableVariants: []
    }
  },
  computed: {
    ...mapState(['session', 'popupSession']),
    selectedProduct: function() {
      return this.selectedExchangeableProduct ? this.selectedExchangeableProduct.to_campaign_product : null
    },
    selectedQuantity: function() {
      return this.selectedExchangeableProduct ? this.selectedExchangeableProduct.quantity : 1
    },
    selectedPrice: function() {
      return Number(this.selectedExchangeableProduct ? this.selectedExchangeableProduct.price : '0')
    },
    selectedVariant: function() {
      return this.selectedExchangeableProduct ? this.selectedExchangeableProduct.to_variant : null
    },
    exchangeablesAreVariants: function() {
      return this.exchangeableVariants && this.exchangeableVariants.length
    },
    exchangeableProducts: function() {
      if (this.exchangeablesAreVariants) {
        return this.exchangeableVariants
      }

      const selectedVariantId = this.selectedItem.variant ? this.selectedItem.variant.id : null

      return this.selectedItem.campaign_product.exchangeable_products.filter(
        exchangeableProduct =>
          (exchangeableProduct.to_campaign_product.id !== this.selectedItem.campaign_product.id) ||
          (exchangeableProduct.quantity !== this.selectedItem.quantity) ||
          ((exchangeableProduct.to_variant ? exchangeableProduct.to_variant.id : null) !== selectedVariantId) ||
          (Number(exchangeableProduct.price) !== Number(this.selectedItem.price))
      )
    },
    totalPrice: function() {
      if (this.isSelected(this.selectedItem.campaign_product, this.selectedItem.quantity, this.selectedItem.unit_price,
        this.selectedItem.variant)
      ) {
        return formatCurrency(this.selectedItem.current_price, this.selectedItem.order.currency)
      }

      const unitPrice = this.selectedExchangeableProduct ? this.selectedExchangeableProduct.price : 0
      return formatCurrency(unitPrice * this.selectedQuantity, this.selectedItem.order.currency)
    },
    activeSession() {
      return this.session && this.session.is_popup && this.popupSession ? this.popupSession : this.session
    }
  },
  methods: {
    isLink: function(input) {
      return input.type === InputType.Link || (input.button_styles && input.button_styles.style_type === StepButtonType.TextOnly)
    },
    isOutlineButton: function(input) {
      return input.button_styles && [StepButtonType.FlatOutline, StepButtonType.ModernOutline].indexOf(input.button_styles.style_type) > -1
    },
    getCustomClass: function(input, includeButtonClass = false) {
      let classes = getClassFromObject(input)
      if (includeButtonClass) {
        if (!this.activeSession.is_legacy) {
          classes += 'input-btn'
          if (this.isOutlineButton(input)) {
            classes += ' input-outline-btn'
          }
        } else {
          classes += 'text-capitalize'
        }
      }
      return classes
    },
    getStyles: function(input) {
      return input && input.button_styles && input.button_styles.style
    },
    sessionInputLabel(input) {
      if (input) {
        return updateFontSizes(input.formatted_label)
      }
      return null
    },
    selectExchangeableProduct(exchangeableProduct) {
      this.selectedExchangeableProduct = exchangeableProduct
    },
    updateQuantity: function(val) {
      const quantity = parseInt(val)

      if (quantity > 0 && (quantity !== this.selectedQuantity)) { // if quantity changed
        this.selectedExchangeableProduct.quantity = quantity
      }
    },
    isSelected: function(campaignProduct, quantity, price, variant) {
      const variantId = variant ? variant.id : null
      const selectedVariantId = this.selectedVariant ? this.selectedVariant.id : null

      if (this.exchangeablesAreVariants) {
        return selectedVariantId === variantId
      }

      return this.selectedProduct &&
        (this.selectedProduct.id === campaignProduct.id) &&
        (this.selectedQuantity === quantity) &&
        (selectedVariantId === variantId) &&
        (!Number.isNaN(Number(price)) && this.selectedPrice === Number(price))
    },
    needsProductSelection: function(input) {
      if (input.id in this.selectProductFields) {
        if (this.selectedProduct) {
          return this.isSelected(this.selectedItem.campaign_product, this.selectedItem.quantity,
            this.selectedItem.unit_price, this.selectedItem.variant)
        }

        return true
      }

      return false
    },
    selectInput(input) {
      if (!this.needsProductSelection(input)) {
        let inputData = null // no data required for input
        let selectedProduct = null

        if (this.selectedProduct && (input.id in this.selectProductFields)) {
          inputData = {}
          selectedProduct = this.selectedProduct

          // build the data required for the input
          inputData[this.selectProductFields[input.id]] = this.selectedProduct.id

          if (this.selectedQuantity) {
            inputData['quantity'] = this.selectedQuantity
          }

          if (this.selectedVariant) {
            inputData['variants'] = [{id: this.selectedVariant.id, quantity: this.selectedQuantity}]
            inputData['variant_is_fixed'] = true
          }
        }

        this.$emit('select', input, inputData, selectedProduct)
      }
    },
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore changes to item selection)
    }
  },
  created() {
    this.$store.commit('busy')
    this.selectedItem = this.item || this.activeSession.selected_item
    if (this.selectedItem) {
      axios.all([
        axios.get('/campaign_products/' + this.selectedItem.campaign_product.id.toString() + '/'),
        axios.get('/order_items/' + this.selectedItem.id.toString() + '/exchangeables/',
          {params: {check_price: this.checkPrice}})
      ]).then(result => {
        this.selectedItem.campaign_product = result[0].data
        const exchangeableProducts = result[1].data.exchangeables
        const variants = result[1].data.variants
        this.selectedItem.campaign_product.exchangeable_products = exchangeableProducts
        this.originalProduct = {
          to_campaign_product: this.selectedItem.campaign_product,
          quantity: this.selectedItem.quantity,
          price: this.selectedItem.unit_price,
          display_name: null,
          sales_phrase: this.selectedItem.product.sales_phrase,
          subtext: this.selectedItem.subtext,
          retail_price: this.selectedItem.retail_price,
          to_variant: this.selectedItem.variant
        }

        if (exchangeableProducts && exchangeableProducts.length) {
          // our product might already be defined in the exchangeable products - so get the data from there
          this.selectedItem.campaign_product.exchangeable_products.some(
            exchangeableProduct => {
              if ((exchangeableProduct.to_campaign_product.id === this.selectedItem.campaign_product.id) &&
                (exchangeableProduct.quantity === this.selectedItem.quantity)) {
                this.originalProduct = exchangeableProduct
                return true
              }

              return false
            }
          )
        } else if (variants && variants.length) {
          // product has no exchangeables, so if there's just one standard variant, use that as the exchangeable product
          variants.forEach(variant => {
            const exchangeable = {
              to_campaign_product: this.selectedItem.campaign_product,
              quantity: this.selectedItem.quantity,
              price: variant.price || this.selectedItem.unit_price,
              display_name: null,
              sales_phrase: null,
              subtext: this.selectedItem.subtext,
              retail_price: variant.retail_price || this.selectedItem.retail_price,
              to_variant: variant
            }

            this.exchangeableVariants.push(exchangeable)
          })
        }

        // get the required product selection fields
        for (const input of this.activeSession.valid_inputs) {
          const keys = Object.keys(input.input_fields)

          keys.forEach(key => {
            const config = input.input_fields[key]

            if (config.type === InputType.Product) {
              this.selectProductFields[input.id] = key // field name for product selection
            } else if (key === 'quantity') {
              if (config.min) {
                this.minQuantity = config.min
              }
              if (config.max) {
                this.maxQuantity = config.max
              }
            }
          })
        }

        this.selectedExchangeableProduct = this.originalProduct
        this.$store.commit('ready')
      }, error => {
        console.error(error)
        this.$store.commit('critical_error', error)
        this.$store.commit('ready')
      })
    } else {
      this.$store.commit('ready')
    }
  }
}
</script>

<style scoped lang="less">
  .ch-prod-bg {
    top: 0;
    left: -50%;
    right: -50%;
    height: 10%;
  }

  .change-product-padding {
    padding: 5px;
  }

  @media screen and (min-width: 415px) {
    .change-product-padding {
      padding: 11px;
    }
  }

  .exchangeable-products-wrapper {
    .title {
      font-size: 18px;
      line-height: 27px;
    }

    .subtitle {
      font-size: 16px;
      line-height: 24px;
    }

    .change-product .order-totals {
      margin-bottom: 10px;
    }

    .welcome hr {
      margin: 12px auto;
    }

    .product-info {
      .product-name {
        font-size: 14px;
      }

      .product-blurb {
        font-size: 12px;
        margin-top: 6px;
      }
    }

    .refund-text {
      text-align: center;
      font-weight: normal;
      font-style: italic;
      font-size: 12px;
      margin-bottom: 12px;

      @media screen and (min-width: 351px) {
        font-size: 14px;
      }

      @media screen and (min-width: 430px) {
        font-size: 16px;
      }

      @media screen and (min-width: 576px) {
        font-size: 16px;
      }

      @media screen and (min-width: 768px) {
        font-size: 18px;
      }

      @media screen and (min-width: 992px) {
        font-size: 20px;
      }

      @media screen and (min-width: 1200px) {
        font-size: 22px;
      }
    }
  }

  @media only screen and (min-width: 351px) and (max-width:375px) {
    .exchangeable-products-wrapper {
      .title {
        font-size: 20px;
        line-height: 30px;
      }

      .subtitle {
        font-size: 17px;
        line-height: 24px;
      }

      .change-product .order-totals {
        margin-bottom: 10px;
      }

      .welcome hr {
        margin: 12px auto;
      }

      .product-info {

        .product-name {
          font-size: 15px;
        }

        .product-blurb {
          font-size: 13px;
        }
      }
    }
  }

  @media only screen and (min-width: 376px) and (max-width:414px) {
    .exchangeable-products-wrapper {
      .title {
        font-size: 21px;
        line-height: 33px;
      }

      .subtitle {
        font-size: 18px;
        line-height: 24px;
      }

      .change-product .order-totals {
        margin-bottom: 10px;
      }

      .welcome hr {
        margin: 12px auto;
      }

      .product-info {

        .product-name {
          font-size: 16px;
        }

        .product-blurb {
          font-size: 14px;
        }
      }
    }
  }

  @media only screen and (min-width: 415px) and (max-width:575px) {
    .exchangeable-products-wrapper {
      .title {
        font-size: 24px;
        line-height: 36px;
      }

      .subtitle {
        font-size: 20px;
        line-height: 27px;
      }

      .change-product .order-totals {
        margin-bottom: 10px;
      }

      .welcome hr {
        margin: 12px auto;
      }

      .product-info {

        .product-name {
          font-size: 16px;
        }

        .product-blurb {
          font-size: 14px;
        }
      }
    }
  }

  @media only screen and (min-width: 501px) and (max-width:767px) {
    .exchangeable-products-wrapper {
      .title {
        margin-top: 24px
      }
    }
  }

  @media only screen and (min-width: 576px) and (max-width:767px) {
    .exchangeable-products-wrapper {
      .title {
        font-size: 30px;
        line-height: 45px;
      }

      .subtitle {
        font-size: 22px;
        line-height: 33px;
      }

      .change-product .order-totals {
        margin-bottom: 10px;
      }

      .welcome hr {
        margin: 12px auto;
      }

      .product-info {

        .product-name {
          font-size: 18px;
        }

        .product-blurb {
          font-size: 16px;
        }
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .exchangeable-products-wrapper {
      .product-info {
        .product-name {
          font-size: 20px;
        }
        .product-blurb {
          margin-top: 0;
        }
      }

      .title {
        font-size: 42px;
        line-height: 62px;
      }

      .subtitle {
        font-size: 26px;
        line-height: 52px;
      }
    }
  }

</style>
